/**
 * Exchange a Clerk session JWT for a Drivenow app JWT via auth-api.
 */

import { AUTH_API_URL, authFetch } from "./authFetch";

export type ClerkSessionExchangeResult = {
  token: string;
  created?: boolean;
  email_verified?: boolean;
};

export async function exchangeClerkSession(
  clerkToken: string
): Promise<ClerkSessionExchangeResult> {
  const res = await authFetch(`${AUTH_API_URL}/clerk/session`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${clerkToken}`,
      "Content-Type": "application/json",
    },
  });

  let data: { token?: string; detail?: string; message?: string; created?: boolean; email_verified?: boolean } = {};
  try {
    data = await res.json();
  } catch {
    // non-JSON body
  }

  if (!res.ok || !data.token) {
    const detail =
      (typeof data.detail === "string" && data.detail) ||
      data.message ||
      `Clerk session sync failed (${res.status})`;
    throw new Error(detail);
  }

  return {
    token: data.token,
    created: data.created,
    email_verified: data.email_verified,
  };
}
